// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"194":"66761edb","477":"ea530f24","789":"b397d9aa","928":"45448e49"}[chunkId] + ".js";
};